import { Alert, Box, Button } from "@mui/material";
import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { useNavigate } from "Navigation/useNavigate";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Social.Handle;

/**
 * Dashboard nudge for users who skipped picking a handle (ZS-1320): backend
 * handleRequired fires only for FullMoone personas with a social-discoverable role and
 * no handle. Links to the profile page, where the handle card's edit dialog hosts
 * the handle editor.
 */
export const HandleMissingBanner = () => {
  const { t } = useResource();
  const navigate = useNavigate();
  // React Query user-info, not the Redux user — after an SPA sign-in the Redux user
  // has no handleRequired (SignInResult doesn't carry it), which would hide the nudge.
  const { data: userInfo } = useUserInfoQuery();

  if (!userInfo?.handleRequired) {
    return null;
  }

  return (
    <Box mt={1}>
      <Alert
        severity="info"
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() =>
              navigate(`${appUrl("user-account")}?activeTab=publicInformation`)
            }
          >
            {t(RESOURCES.MissingBannerAction)}
          </Button>
        }
      >
        {t(RESOURCES.MissingBannerText)}
      </Alert>
    </Box>
  );
};
